<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input placeholder="请输入内容" v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="演出名称" :value="2"></el-option>
                            <el-option label="巡演ID" :value="3"></el-option>
                            <el-option label="主题ID" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">                    
                    <el-select v-model="params.status" placeholder="请选择" size="small">                        
                        <el-option label="仅看待审核的" :value="1"></el-option>
                        <el-option label="仅看已通过的" :value="2"></el-option>
                        <el-option label="仅看已拒绝的" :value="3"></el-option>   
                        <el-option label="不限制审核状态" :value="0"></el-option>                     
                    </el-select>
                </el-col>
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">                    
                    <el-select v-model="params.activityType" placeholder="请选择" size="small">
                        <el-option label="不限制演出类型" :value="0"></el-option>
                        <el-option label="仅看Livehouse的" :value="1"></el-option>
                        <el-option label="仅看音乐节的" :value="2"></el-option>
                        <el-option label="仅看剧场的" :value="3"></el-option>     
                        <el-option label="仅看演唱会的" :value="4"></el-option>                        
                    </el-select>
                </el-col> -->
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">                    
                    <el-select v-model="params.orderType" placeholder="请选择" size="small">
                        <el-option label="优先展示最早提交审核的" :value="1"></el-option>
                        <el-option label="优先展示最晚提交审核的" :value="2"></el-option>
                        <el-option label="优先展示最新审核的" :value="3"></el-option>                       
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button v-if="$utils.have('/activity/updateAudit/list')"  type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button v-if="$utils.have('/activity/updateAudit/list')" type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="审核状态">
                    <template slot-scope="scope">
                        {{ scope.row.status && statusMap.get(scope.row.status) }}
                    </template>
                </el-table-column>
                <!-- <el-table-column label="演出类型">
                    <template slot-scope="scope">
                        {{ scope.row.type && activityMap.get(scope.row.type) }}
                    </template>
                </el-table-column>
                <el-table-column label="城市" prop="cityName"></el-table-column>  -->
                <el-table-column label="ID" prop="activityId"></el-table-column>                 
                <el-table-column label="名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link class="ellipsis title" @click="$refs.H5Preview.show('/pages/activity/detail/detail?activityId='+scope.row.activityId)">
                            {{ scope.row.activityNameStr || scope.row.activityName }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column label="发起人" prop="startUserName" show-overflow-tooltip min-width="100"></el-table-column> 
                <el-table-column label="提交审核时间" prop="createTime" min-width="150"></el-table-column>  
                <el-table-column label="审核人" prop="auditorName"></el-table-column>  
                <el-table-column label="审核时间" prop="auditTime" min-width="150"></el-table-column> 
                <el-table-column fixed="right" label="操作" width="120" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            v-if="$utils.have('/activity/updateAudit/detail')"
                            icon="el-icon-view"
                            @click="toDetail(scope.row.id)"
                            >查看</el-button>
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="view(scope.row)"
                            >预览</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
        <GoodsView ref="goodsView"></GoodsView>
        <H5Preview ref="H5Preview"></H5Preview>
    </div>
</template>
<script>
import { nameMap } from './components/mixins.js';
import GoodsView from '@/components/CodeView';
import H5Preview from '@/components/H5Preview';
const defaultParams = {
    pageNo: 1,
    // pageSize: 20,
    searchType: 1,
    searchValue: '',
    status: 1,
    // activityType: 0,
    orderType: 1
}
export default {
    mixins: [nameMap],
    components:{GoodsView,H5Preview},
    data() {
        return {
            data: null,
            dataList: null,
            params: { 
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                status: parseInt(this.$route.query.status || 1),
                // activityType: parseInt(this.$route.query.activityType || 0),
                orderType: parseInt(this.$route.query.orderType || 1),
            },
            listLoading: true,
            sswap:process.env.VUE_APP_SSWAP_URL,
        };
    },
    mounted() {
        this.getDataList();
    },    
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            const data = {...this.params};
            // if(data.activityType == 0) delete data.activityType;
            if(data.status == 0) delete data.status;
            this.$request({
                url: "/activity/updateAudit/list",
                method: "POST",
                data,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        const data = result.result || [];
                        if(data.length){
                            data.forEach(item=> {
                                // item.siteLink = `${process.env.VUE_APP_SSWEB_URL}/event/${item.id}`
                                if(item.activityName && item.activityName.length>40){
                                    item.activityNameStr = item.activityName.slice(0,40) + '...'
                                }
                            })
                        }
                        this.dataList = data;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                }).catch(() => {
                    this.$message.error("请求失败");
                }).finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            }
            this.getDataList();
        },
        toDetail(recordId){
            // this.$router.push({name: 'edit-verify-detail', params: {recordId}})
            this.$router.push({
                name: 'edit-verify-detail', 
                params: {recordId},
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        //预览
        view(item){
            this.$refs.goodsView.show({
                ...item,
                title: item.activityNameStr || item.activityName,
				showWechart:0,
                qrCodeUrl: this.sswap+'/pages/activity/detail/detail?activityId='+item.activityId
            })
        },
    }
};
</script>
